<template>
<div>
  <v-card max-width="1700px" style="margin: auto; box-shadow: none;">
      <v-app-bar style="top: 64px" fixed :color="defunt.sexe=='Masculin' ? 'blue white--text' : 'pink white--text'" dark>
        <v-spacer></v-spacer>
        <v-toolbar-title>{{denom}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn exact :to="{name: 'defuntInfo'}" text dark icon>
          <v-icon>mdi-information-variant</v-icon>
        </v-btn>
        <v-btn :to="{name: 'contact'}" text dark icon>
          <v-icon>mdi-account-box</v-icon>
        </v-btn>
        <v-btn :to="{name: 'servicesFunebres'}" icon>
          <v-icon>mdi-room-service</v-icon>
        </v-btn>
        <v-btn :to="{name: 'avisMortuaire'}" icon>
          <v-icon>mdi-text-subject</v-icon>
        </v-btn>
        <v-btn :to="{name: 'devis'}" icon>
          <v-icon>mdi-cart</v-icon>
        </v-btn>
        <v-btn :to="{name: 'recap'}" icon>
          <v-icon>mdi-check-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{on, attrs}">
              <v-btn icon v-bind="attrs" v-on="on" dark>
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>

              <v-list-item :to="{name: 'photo'}">
                <v-list-item-title>Photo</v-list-item-title>
              </v-list-item>

              <v-list-item v-if="!defunt.archive" @click="archiveDef(1)">
                <v-list-item-title>Archiver</v-list-item-title>
              </v-list-item>

              <v-list-item v-if="defunt.archive" @click="archiveDef(0)">
                <v-list-item-title>Remettre en cours</v-list-item-title>
              </v-list-item>

              <v-list-item v-if="user.group == 'admin'" @click="showChangeResp">
                <v-list-item-title>Changer le résponsable</v-list-item-title>
              </v-list-item>

              <v-list-item @click.stop="askDeleteDef()">
                <v-list-item-title>Supprimer le défunt</v-list-item-title>
              </v-list-item>

            </v-list>
          </v-menu>
          <v-spacer></v-spacer>
      </v-app-bar>
    <v-card-text>
      <transition name="fade" mode="out-in">
          <router-view :sexe="defunt.sexe"></router-view>
      </transition>
    </v-card-text>
  </v-card>

    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
          <v-card-title>{{"Supprimer " + denom + " ?"}}</v-card-title>
          <v-card-text>Pour confirmer tapez "supprimer" ci-dessous</v-card-text>
          <v-card-text>
            <v-text-field label="Confirmation" v-model="confirmed"></v-text-field>
          </v-card-text>
  
        <v-card-actions>
          <v-btn :loading="delLoad" :disabled="delLoad" v-if="confirmed == 'supprimer'" class="red--text darken-1" text @click.native.stop="deleteDef()">Supprimer</v-btn>
          <v-btn text @click.native="dialog = false">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogChangeResp" max-width="500px">
      <v-card>
          <v-card-title>{{denom + " attribué à " + createdByName}}</v-card-title>
          <v-card-text>Nouveau résponsable : {{resp.name}}</v-card-text>
        <v-card-actions>
          <v-btn-toggle mandatory v-model="resp">
            <v-btn :value="elem" class="primary mr-1" v-for="elem in usersList" :key="elem.id">{{elem.name}}</v-btn>
          </v-btn-toggle>
        </v-card-actions>
        <v-card-actions>
          <v-btn @click.native="dialogChangeResp = false">Annuler</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="warning" text @click.native="changeResp(resp.id)">Changer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</div>
</template>

<script>
    import {ajax_post} from '../../public/global.js'
    import currentUser from "../store/currentUser"
    export default {
      data(){
        return{
          defunt: {
            sexe: 'Masculin',
            prenom: '',
            nom:'',
            archive: '',
            idCreatedBy: ''
          },
          dialog: false,
          dialogChangeResp: false,
          confirmed: '',
          delLoad: false,
          recapDialog: false,
          user: currentUser.user,
          usersList: {},
          createdByName : '',
          resp: {}
        }
      },
      computed: {
        denom(){
          if(this.defunt.prenom == '' && this.defunt.nom == ''){
            if(this.defunt.sexe=='Masculin'){
              return 'Défunt'
            }else{
              return 'Défunte'
            }
          }else{
            return this.defunt.prenom + ' ' + this.defunt.nom
          }
        }        
      },
      methods: {
        fetchData () {
          ajax_post(`/PHP/ajax/returnDef.php`,`id=${this.$route.params.id}&token=${this.$token()}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
              let defuntRecup = rep.data
              this.defunt.sexe = defuntRecup.sexe
              this.defunt.prenom = defuntRecup.prenom
              this.defunt.nom = defuntRecup.nom
              this.defunt.idCreatedBy = defuntRecup.createdBy
              this.defunt.archive = defuntRecup.archive == 1 ? true : false
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        askDeleteDef(){
          this.dialog = true
        },
        deleteDef(){
          this.delLoad = true
          ajax_post(`/PHP/ajax/deleteDef.php`,`id=${this.$route.params.id}&token=${this.$token()}`).then((response)=>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.$root.$emit('myinfo', {title: "Serenity", msg: "Suppression réussie !", color: ""})
              this.dialog = false
              this.delLoad = false
              this.$router.push({path: '/'})
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        archiveDef(num){
          ajax_post(`/PHP/ajax/archiveDef.php`,`id=${this.$route.params.id}&token=${this.$token()}&num=${num}`).then((response)=>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: ""})
              this.$router.push({path: '/'})
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        showChangeResp() {
          ajax_post(`/PHP/ajax/returnUsersList.php`, `token=${this.$token()}&idCreatedBy=${this.defunt.idCreatedBy}`).then((response)=>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.usersList = rep.data.usersList
              this.createdByName = rep.data.currentUser.name
              this.dialogChangeResp = true
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },
        changeResp(userId) {
          ajax_post(`/PHP/ajax/changeResp.php`, `id=${this.$route.params.id}&token=${this.$token()}&userId=${userId}`).then((response)=>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.fetchData()
              this.$root.$emit('myinfo', {title: "Serenity", msg: "Changement de résponsable réussie !", color: ""})
              this.dialogChangeResp = false
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        }
      },
      created () {
        this.fetchData()
        this.$root.$on('sexeChang', (val) =>{
          this.defunt.sexe = val
        })
        this.$root.$on('prenomChang', (val) =>{
          this.defunt.prenom = val
        })
        this.$root.$on('nomChang', (val) =>{
          this.defunt.nom = val
        })
      },
      watch: {
        '$route': 'fetchData'
      }
    }
</script>
<style>
  .v-btn--active{
    background-color: #000;
  }
</style>